import { httpClient } from './httpClient';

const base = '/api/materias';

export const listarMaterias = (filtros = {}) => {
  const params = new URLSearchParams();
  if (filtros.nombre) params.append('nombre', filtros.nombre);
  if (filtros.sigla) params.append('sigla', filtros.sigla);
  if (filtros.activo !== undefined) params.append('activo', filtros.activo);
  
  const query = params.toString();
  return httpClient.get(query ? `${base}?${query}` : base);
};

export const obtenerMateria = (id) => httpClient.get(`${base}/${id}`);

export const obtenerMateriasPorCurso = (cursoId) => 
  httpClient.get(`${base}/curso/${cursoId}`);

export const crearMateria = (payload) => httpClient.post(base, payload);

export const actualizarMateria = (id, payload) => 
  httpClient.put(`${base}/${id}`, payload);

export const eliminarMateria = (id) => httpClient.del(`${base}/${id}`);

const materiasService = {
  listar: listarMaterias,
  obtener: obtenerMateria,
  obtenerPorCurso: obtenerMateriasPorCurso,
  crear: crearMateria,
  actualizar: actualizarMateria,
  eliminar: eliminarMateria,
};

export default materiasService;
